<template>
  <v-list-item
    :key="`${link.label}-header-link`" 
    :to="link.url"
    class="py-2"
  >
    <span>
      <v-tooltip 
        :open-delay="tooltipDelay"
        right 
        max-width="200px"
        :key="`${link.label}-header-link`" 
      >
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on" class="d-flex">
            <!-- Customer menu icons-->
            <v-list-item-icon v-if="role === 'customer'" class="mr-5">
              <v-icon large :color="link.color">{{ link.icon }}</v-icon>
            </v-list-item-icon>
            <!-- Admin menu icons-->
            <v-list-item-icon v-else>
              <v-icon large :color="link.color">{{ link.icon }}</v-icon>
              <!-- Badge on Requests menu item -->
              <v-badge
                v-if="link.url === '/requests' && pendingRequests > 0"
                color="primary"
                :content="pendingRequests"
                overlap
              >
              </v-badge>
            </v-list-item-icon>
            <!-- Customer menu list titles -->
            <v-list-item-title v-if="role === 'customer'" class="d-flex justify-start">
              <div class="list-item">{{ link.label }}</div>
            </v-list-item-title>
          </span>
        </template>
        <span>{{ link.tooltip }}</span>
      </v-tooltip>
    </span>
  </v-list-item>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: ['link'],
    computed: {
      ...mapGetters({
        tooltipDelay: 'users/getTooltipDelay',
        userAccounts: 'users/getUserAccounts'
      }),
      pendingRequests() {
        return this.userAccounts.filter((account) => !('approvedBy' in account) || account.approvedBy.length === 0).length
      }
    },
    created(){
      const userData = JSON.parse(sessionStorage.getItem('user'))
      this.role = userData.role;
    },
    data() {
      return {
        role: 'customer',
      }
    }
  }
</script>

<style lang="scss" scoped>
  
</style>